"use strict";
// Copyright (c) 2024 The Bitcoin developers
// Distributed under the MIT software license, see the accompanying
// file COPYING or http://www.opensource.org/licenses/mit-license.php.
Object.defineProperty(exports, "__esModule", { value: true });
exports.sha256 = sha256;
exports.sha256d = sha256d;
exports.shaRmd160 = shaRmd160;
exports.sha512 = sha512;
exports.sha256Hasher = sha256Hasher;
exports.sha512Hasher = sha512Hasher;
exports.__setHashes = __setHashes;
const HASHES = {};
function sha256(data) {
    return HASHES.sha256(data);
}
function sha256d(data) {
    return HASHES.sha256d(data);
}
function shaRmd160(data) {
    return HASHES.shaRmd160(data);
}
function sha512(data) {
    return HASHES.sha512(data);
}
function sha256Hasher() {
    return new HASHES.Sha256H();
}
function sha512Hasher() {
    return new HASHES.Sha512H();
}
function __setHashes(hashes) {
    HASHES.sha256 = hashes.sha256;
    HASHES.sha256d = hashes.sha256d;
    HASHES.shaRmd160 = hashes.shaRmd160;
    HASHES.sha512 = hashes.sha512;
    HASHES.Sha256H = hashes.Sha256H;
    HASHES.Sha512H = hashes.Sha512H;
}
//# sourceMappingURL=hash.js.map